import { createContext } from 'react';
import { WebSection } from '@wbk/contentful/api';

export type LocalWebCard = WebSection['contentCollection']['items'][0];

type Props = {
  anchors?: WebSection;
  setAnchors?: (anchors: WebSection) => void;
  targetRef?: React.RefObject<HTMLElement | null>;
  selectedAnchorCard?: LocalWebCard | null;
  setSelectedAnchorCard?: (card: LocalWebCard | null) => void;
};

const ZonesContext = createContext<Props>({
  anchors: undefined,
  setAnchors: () => {},
  targetRef: undefined,
  selectedAnchorCard: null,
  setSelectedAnchorCard: () => {},
});

export default ZonesContext;
